{
  "it": {
    "reminder": {
      "actions": {
        "cancel": "Annulla",
        "edit": "Modifica",
        "hideReminders": "Nascondi promemoria",
        "save": "Salva",
        "showReminders": "Mostra promemoria"
      },
      "contactType": {
        "customer": "Cliente",
        "partner": "Partner"
      },
      "labels": {
        "after": "dopo",
        "before": "prima",
        "click": "Faccia clic qui per impostare il promemoria",
        "date": "il {date}",
        "dateAfterDueDate": "Dopo la scadenza",
        "dateAlreadyPassed": "la data è già trascorsa",
        "decisionApprovedNotSent": "La decisione è stata presa. I promemoria ancora in coda sono stati annullati.",
        "dueDate": "la scadenza",
        "editTitle": "Modifica promemoria",
        "here": "qui",
        "infoReminders": "I promemoria sono attivi solo per le rate con una scadenza impostata.",
        "noReminderSet": "Nessun promemoria impostato",
        "reminder": "Promemoria",
        "reminders": "Promemoria",
        "remindersCustomer": "Promemoria per il Suo cliente",
        "remindersPartners": "Promemoria per il/i partner",
        "reminders_count": "{count} promemoria impostato | {count} promemoria impostati",
        "sendOnDeadline": "Il promemoria sarà inviato alla scadenza",
        "sendReminder": "Invia promemoria",
        "sent_at": "Promemoria inviato il {date}",
        "warningReminders": "Questa azione sostituisce tutti e 4 i promemoria. Ogni promemoria lasciato vuoto qui sarà rimosso per ogni decisione."
      },
      "toasts": {
        "update": "Promemoria aggiornato con successo"
      }
    }
  }
}
